export default {
	faqs: {
		createCategory: 'Kategorie anlegen',
		createEntry: 'Eintrag anlegen',
		faqCategory: 'FAQ Kategorie | FAQ Kategorien',
		faqEntry: 'FAQ Eintrag | FAQ Einträge',
	},
}
